import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { IntlProvider, injectIntl } from 'react-intl-next';
import { ENGLISH_LOCALES, getMessagesForLocale } from '../../utils/i18n-util';
import english_messages from '../../i18n/en';
class MessagesIntlProvider extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "fetchLocale", () => {
      getMessagesForLocale(this.props.intl.locale).then(messages => this.setState({
        messages: messages
      }));
    });
    this.state = {
      messages: ENGLISH_LOCALES.indexOf(props.intl.locale) !== -1 ? english_messages : undefined
    };
    this.fetchLocale();
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(IntlProvider, {
      messages: this.state.messages,
      locale: this.props.intl.locale
    }, children);
  }
}
const MessagesIntlProviderWithIntl = injectIntl(MessagesIntlProvider);
export default MessagesIntlProviderWithIntl;